





































import { Vue, Component, Prop } from 'vue-property-decorator';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { SelectOptionInterface } from '@shared/interfaces/inputs';

@Component({
  components: {
    'bpc-search-input': SearchInput,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
  },
})
export default class AccessPointFilters extends Vue {
  // PROPS
  @Prop({ type: Object, required: true }) value!: {
    search: string | null;
    resource_ids: number[];
    status: string[];
  };
  @Prop({ type: Function, required: true }) readonly clickOnReload!: () => void;

  // COMPUTED
  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get hideInputLabel() {
    return {
      labelAttributes: {
        for: 'input',
      },
    };
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  get statusOptions(): SelectOptionInterface[] {
    return [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
      {
        text: 'global.fields.status.trash.label',
        value: 'trash',
      },
    ];
  }
}
